import { isZoomEnabledFor } from './axis-interactions.js';
import { getInitialZoomOut } from '../../core/components/zoom/utils/get-initial-zoom-out.js';
import type { MinMax } from '../../core/types/min-max.js';
import { safeGet } from '../../core/utils/safe-get.js';
import type {
  AxisIdToScaleDomain,
  XYChartAxisInternal,
} from '../types/xy-chart-internals.js';

function getMinMax(axisIdToScaleDomain: AxisIdToScaleDomain, axisId: string) {
  const aux = safeGet(axisIdToScaleDomain, axisId) as MinMax;
  return [aux.min, aux.max];
}

export function isZoomOutAllowed(
  axes: XYChartAxisInternal[],
  axisIdToScaleDomain: AxisIdToScaleDomain,
) {
  const zoomableAxes = axes.filter(isZoomEnabledFor);

  if (zoomableAxes.length === 0) {
    return false;
  }

  return zoomableAxes.every((axis) => {
    if (axis.interactions.infinite) {
      return true;
    }

    return getInitialZoomOut(
      axis.interactions.current,
      axis.interactions.initial ?? getMinMax(axisIdToScaleDomain, axis.id),
    );
  });
}
